// This code is very fragile and will be going away eventually, so let's not worry about making TypeScript happy.
// @ts-nocheck

import { find, isEqual, omit, pick } from 'lodash';

import { AccountPlan, Interval } from '@zapier/design-system-revenue/src/types';

type MonthlyDivisors = {
  [x in Interval]: number;
};

const sortPlanIntervals = (plans: Array<AccountPlan>): Array<AccountPlan> =>
  plans.map(plan => ({
    ...plan,
    // make 'year' come first
    intervals: plan.intervals.sort((a, b) =>
      b.interval.localeCompare(a.interval)
    ),
  }));

// Merge monthly and yearly account plans into consolidated objects.
export const intervalizePlans = (accountPlans: Array<AccountPlan>) => {
  const commonProps = ['id', 'amount', 'interval'];
  const monthlyDivisors: MonthlyDivisors = {
    year: 12,
    month: 1,
  };

  accountPlans = accountPlans.map(accountPlan => {
    // If the user switched plan groups, and their current plan is in the old
    // plan group, append '(Legacy)' to the name. This also protects us if the
    // new plan group has a plan with the same name.
    if (accountPlan.off_plan_group) {
      return { ...accountPlan, name: `${accountPlan.name} (Legacy)` };
    }

    return accountPlan;
  });

  const plans = accountPlans.reduce((results, plan) => {
    // current plan is going away
    const newPlan = omit(plan, commonProps.concat('current_plan'));
    const interval = pick(plan, [...commonProps]);
    const div = monthlyDivisors[interval.interval];

    interval.monthlyAmount = div ? Math.round(interval.amount / div) : null;

    const ignore = ['meta', 'change_details', 'max_metering_charge'];
    const mergeWith = find(results, existing =>
      isEqual(omit(existing, ['intervals', ...ignore]), omit(newPlan, ignore))
    );

    if (mergeWith) {
      mergeWith.intervals.push(interval);
    } else {
      newPlan.intervals = [interval];
      results.push(newPlan);
    }

    return results;
  }, []);

  return sortPlanIntervals(plans);
};
